/**
 * Created by griga on 7/11/16.
 */
import { Routes, RouterModule } from '@angular/router';
import { MainLayoutComponent } from "./shared/layout/app-layouts/main-layout.component";
import { AuthLayoutComponent } from "./shared/layout/app-layouts/auth-layout.component";
import { EmptyLayoutComponent } from "./shared/layout/app-layouts/empty-layout.component";
import { ModuleWithProviders } from "@angular/core";
import { AuthGuard } from './auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: EmptyLayoutComponent, canActivate: [AuthGuard],
    children: [
      {
        path: 'data/sunrise', loadChildren: './+data/sunrise/sunrise.module#SunriseModule',
        data: { pageTitle: 'Sunrise' }
      },
      {
        path: 'data/kmsj', loadChildren: './+data/kmsj/kmsj.module#KmsjModule',
        data: { pageTitle: 'KMSJ' }
      },
      {
        path: 'data/leak', loadChildren: './+data/leak/leak.module#LeakModule',
        data: { pageTitle: 'LEAK' }
      },
      {
        path: 'data/xpro', loadChildren: './+data/xpro/xpro.module#XproModule',
        data: { pageTitle: 'xpro' }
      },
      {
        path: 'data/demoXpro',  loadChildren: './+data/demoXpro/demoXproQubesense.module#DemoXproModule',
        data: { pageTitle: 'demoXpro' }
      },
      {
        path: 'data/imvo-kznc', loadChildren: './+data/imvo-kznc/imvo-kznc.module#ImvoKzncModule',
        data: { pageTitle: 'IMVO-KZNC' }
      },
      {
        path: 'data/smat-nasa', loadChildren: './+data/smat-nasa/nasa.module#NasaModule',
        data: { pageTitle: 'NASA' }
      },

      {
        path: 'data/smat-nudb', loadChildren: './+data/smat-nudb/nudb.module#NudbModule',
        data: { pageTitle: 'NUDB' }
      },
      {
        path: 'data/ignt', loadChildren: './+data/ignt/ignt.module#IgntModule',
        data: { pageTitle: 'IGNT' }
      },
      // {
      //   path: 'data/smat-mlpn', loadChildren: './+data/smat-mlpn/mlpn.module#MlpnModule',
      //   data: { pageTitle: 'mlpn' }
      // },
    ]
  },
  {
    path: '',
    component: MainLayoutComponent, canActivate: [AuthGuard],
    children: [
      {
        path: '', redirectTo: 'home', pathMatch: 'full'
      },
      {
        path: 'home',
        loadChildren: './+home/home.module#HomeModule',
      },
      {
        path: 'miscellaneous',
        loadChildren: './+miscellaneous/miscellaneous.module#MiscellaneousModule',
        data: { pageTitle: 'Miscellaneous' }
      },
      {
        path: 'admin', loadChildren: './+admin/admin.module#AdminModule',
        data: { pageTitle: 'Admin' }
      },
      {
        path: 'data', loadChildren: './+data/data.module#DataModule',
        data: { pageTitle: 'Data' }
      }
      ,
      {
        path: 'data/material', loadChildren: './+data/material/material.module#MaterialModule',
        data: { pageTitle: 'Material' }
      }
      ,
      {
        path: 'data/sunrise', loadChildren: './+data/sunrise/sunrise.module#SunriseModule',
        data: { pageTitle: 'Sunrise' }
      },
      {
        path: 'data/enss', loadChildren: './+data/enss/enss.module#EnssModule',
        data: { pageTitle: 'ENSS' }
      },
      {
        path: 'data/kmsj', loadChildren: './+data/kmsj/kmsj.module#KmsjModule',
        data: { pageTitle: 'KMSJ' }
      },
      {
        path: 'data/leak', loadChildren: './+data/leak/leak.module#LeakModule',
        data: { pageTitle: 'LEAK' }
      },
      {
        path: 'data/xpro', loadChildren: './+data/xpro/xpro.module#XproModule',
        data: { pageTitle: 'xpro' }
      },
      {
        path: 'data/demoXpro', loadChildren: './+data/demoXpro/demoXproQubesense.module#DemoXproModule',
        data: { pageTitle: 'demoXpro' }
      },
      {
        path: 'data/demo', loadChildren: './+data/demo/demo.module#DemoModule',
        data: { pageTitle: 'Demo' }
      },
      {
        path: 'data/mrsd', loadChildren: './+data/mrsd/mrsd.module#MrsdModule',
        data: { pageTitle: 'mrsd' }
      },
      {
        path: 'data/smat-nasa', loadChildren: './+data/smat-nasa/nasa.module#NasaModule',
        data: { pageTitle: 'NASA' }
      },
      {
        path: 'data/smat-nudb', loadChildren: './+data/smat-nudb/nudb.module#NudbModule',
        data: { pageTitle: 'NUDB' }
      },
      {
        path: 'data/smat-mlpn', loadChildren: './+data/smat-mlpn/mlpn.module#MlpnModule',
        data: { pageTitle: 'MLPN' }
      },
      {
        path: 'data/ignt', loadChildren: './+data/ignt/ignt.module#IgntModule',
        data: { pageTitle: 'IGNT' }
      },
      {
        path: 'data/imvo-kznc', loadChildren: './+data/imvo-kznc/imvo-kznc.module#ImvoKzncModule',
        data: { pageTitle: 'IMVO-KZNC' }
      },
    ]
  },
  { path: 'auth/imvo', component: EmptyLayoutComponent, loadChildren: './+auth/auth.module#AuthModule' },
  { path: 'auth', component: AuthLayoutComponent, loadChildren: './+auth/auth.module#AuthModule' },
  { path: 'image', component: EmptyLayoutComponent, loadChildren: './+nolayout/nolayout.module#NoLayoutModule' },
  
 ];
export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: true });
